export const GET_PROMO_CODE_DETAILS = "GET_PROMO_CODE_DETAILS"
export const GET_PROMO_CODE_DETAILS_SUCCESSFUL = "GET_PROMO_CODE_DETAILS_SUCCESSFUL"
export const GET_PROMO_CODE_DETAILS_FAILED = "GET_PROMO_CODE_DETAILS_FAILED"
export const GET_PROMO_CODE_DETAILS_RESET = "GET_PROMO_CODE_DETAILS_RESET"
